import { Button, Typography } from "@mui/material";
import ModalPopup from "components/core/modal-components/ModalPopup";
import { t } from "i18next";
import React from "react";
import { dataDogErrorLog, handleRefId } from "utils/helpers";

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, refId: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    const { refId, message } = handleRefId(error);
    dataDogErrorLog(
      message,
      ``,
      {
        error
      },
      refId
    );
    this.setState({ refId });
  }

  render() {
    if (this.state.hasError) {
      return (
        <ModalPopup
          modalPopupOpen={true}
          throwError={true}
          alertMessage={
            <>
              <Typography>{t("common.systemErrorMessage")}</Typography>
              <Typography variant="caption">
                {t("common.referenceID")}: {this.state.refId}
              </Typography>
            </>
          }
          modalButton={
            <Button
              variant="contained"
              onClick={() => {
                this.setState({ hasError: false });
              }}
            >
              {t("common.close")}
            </Button>
          }
          message={" "}
          title={t("dashboard.errorOccurred")}
        />
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
